<template>
  <div class="c2">
    <div class="c2-content">
      <div class="list-head">
        <!-- <div style="width:20px;"></div> -->
        <div
          class="text"
          :style="{ width: widthMap[i] + 'px' }"
          v-for="(item, i) in valueMap"
          :key="i"
        >
          {{ item.name }}
        </div>
      </div>
      <div
        class="text-area"
        ref="content"
        @mouseenter="mouseenterEvent()"
        @mouseleave="mouseleaveEvent()"
      >
        <div class="list-content" ref="scroll1">
          <div class="list-item" v-for="(item, i) in defaultdata" :key="i">
            <!-- <img src="@/assets/temimg2/disc.png" alt="" style="width:20px;position: relative;left: 4px;"> -->
            <div
              class="text"
              :title="item[del.key]"
              :style="{ width: widthMap[i] + 'px', maxWidth: widthMap[i] + 'px', color: i == 0 ? '#A5C1E7' : '' }"
              v-for="(del, i) in valueMap"
              :key="i"
            >
              <span>{{ item[del.key] }}</span>
            </div>
          </div>
        </div>
        <div class="list-content" ref="scroll2" v-if="defaultdata.length > 4">
          <div class="list-item" v-for="(item, i) in defaultdata" :key="i">
            <!-- <img src="@/assets/temimg2/disc.png" alt="" style="width:20px;position: relative;left: 4px;"> -->
            <div
              class="text"
              :title="item[del.key]"
              :style="{ width: widthMap[i] + 'px', maxWidth: widthMap[i] + 'px', color: i > 1 ? '#A5C1E7' : '' }"
              v-for="(del, i) in valueMap"
              :key="i"
            >
              <span>{{ item[del.key] }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as methods from "./method.js";
export default {
  name: "template.scope100",
  props: {
    vdata: {
      type: Array,
      default: () => [],
    },
    jsondata: {
      type: [Array, String],
      default: () => [],
    },
    valuemap: {
      type: [Array, String],
      default: () => [],
    },
    scopedata: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isList: true,
      textnum: 127,
      timer: null,
      defaultdata: [
        {
          value1: "1",
          value2: "标题一xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
          value3: "0000",
          value4: "0000",
          value5: "0000",
        },
        {
          value1: "2",
          value2: "标题二xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
          value3: "0000",
          value4: "0000",
          value5: "0000",
        },
        {
          value1: "3",
          value2: "标题三xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
          value3: "0000",
          value4: "0000",
          value5: "0000",
        },
        {
          value1: "4",
          value2: "标题四xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
          value3: "0000",
          value4: "0000",
          value5: "0000",
        },
        {
          value1: "5",
          value2: "标题五xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
          value3: "0000",
          value4: "0000",
          value5: "0000",
        },
      ],
      valueMap: [
        { name: "序号", key: "value1" },
        { name: "标题", key: "value2" },
        { name: "数据一", key: "value3" },
        { name: "数据二", key: "value4" },
        { name: "数据三", key: "value5" },
      ],
      widthMap: [60, 475, 120, 120, 120],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      config: {},
      autoTimePaused: false,
    };
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        const box = this.$refs.content;
        box.scrollTop = 0;
        this.defaultdata = n;
      }
    },
    valuemap(n) {
      if (n && n.length) {
        const box = this.$refs.content;
        box.scrollTop = 0;
        this.valueMap = n;
      }
    },
    jsondata(n) {
      this.exceldata = n;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.rollUp(70);
    });
    if (this.valuemap && this.valuemap.length) {
      this.valueMap = this.valuemap;
    }
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata;
    }
    this.setData()
  },
  methods: {
    ...methods,
    rollUp(t) {
      const ulf1 = this.$refs.scroll1;
      const box = this.$refs.content;
      if (ulf1.offsetHeight > 120) {
        box.scrollTop = 0;
        this.timer = setInterval(this.rollStart, t);
      } else if (ulf1.offsetHeight == 0) {
        setTimeout(() => {
          this.rollUp(70);
        }, 200);
      }
    },
    rollStart() {
      const ulf1 = this.$refs.scroll1;
      const box = this.$refs.content;
      if (box.scrollTop >= ulf1.scrollHeight) {
        box.scrollTop = 0;
      } else {
        box.scrollTop += 1;
      }
    },
    mouseenterEvent() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    mouseleaveEvent(t) {
      if (!this.timer) {
        this.timer = setInterval(this.rollStart, 70);
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>

<style scoped lang="scss">
.c2 {
  width: 895px;
  height: 240px;
  margin: 0px auto 0 auto;
  position: relative;
  overflow: hidden;
  pointer-events: auto;
  cursor: pointer;
  padding: 10px 0;
  .head {
    width: 100%;
    height: 46px;
    position: relative;
    display: flex;
    align-items: center;
  }

  .title-img {
    width: 100%;
    height: 46px;
    left: 0;
    top: 3px;
    position: absolute;
  }

  .layerName {
    margin-left: 42px;
    z-index: 1;
    font-family: "pmzd";
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    line-height: 15px;
    // text-shadow: 0px 0px 10px rgba(41, 81, 202, 0.8), 0px 0px 10px rgba(41, 81, 202, 0.8), 0px 0px 10px rgba(41, 81, 202, 0.8);
  }

  .layerEng {
    margin-left: 12px;
    z-index: 1;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #8798ac;
    line-height: 15px;
  }

  .more {
    margin: 0 24px 0 auto;
    z-index: 1;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #51a0f4;
    line-height: 15px;
    cursor: pointer;
    pointer-events: auto;
  }

  .text {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    // width: 103px;
    // max-width: 103px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
    padding: 0 10px;
    box-sizing: border-box;
    img {
      width: 23px;
      height: 19px;
    }
  }

  .list-head {
    display: flex;
    height: 43px;
    align-items: center;

    .text {
      color: #6ca9e6;
    }
  }

  .list-item {
    display: flex;
    align-items: center;
    padding: 12px 0;
    min-height: 18px;
    background: rgba(59, 120, 177, 0.05);

    .text {
      color: #a5c1e7;
    }

    &:nth-child(2n + 1) {
      background: rgba(59, 120, 177, 0.16);
    }
  }

  .list-icon {
    width: 32px;
    height: 13px;
    position: relative;

    img {
      width: 17px;
      height: 13px;
      position: absolute;
      right: 0;
    }
  }

  .text-area {
    pointer-events: auto;
    max-height: 198px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 0;
    }
  }
  .c2-content {
    height: 100%;
  }
}
</style>
